import "./App.css";
import React from "react";
import { Analytics } from "@vercel/analytics/react";
import {
  Container,
  Box,
  Typography,
  IconButton,
  Switch,
} from "@mui/material";
import { useTheme, ThemeProvider, createTheme } from "@mui/material/styles";
import { Brightness4, Brightness7 } from "@mui/icons-material";
import Loading from "./components/loading";

const mainColor = "#33CCFF";
const Bundle = React.lazy(() => import("./components/bundle"));
const ColorModeContext = React.createContext({ toggleColorMode: () => {} });

const AppBar = () => {
  const theme = useTheme();
  const colorMode = React.useContext(ColorModeContext);

  return (
    <Box sx={{ pt: 2, pb: 2, mb: 10 }}>
      <Typography fontWeight={600} component="span">
        Theme{" "}
      </Typography>
      <Switch
        checked={theme.palette.mode === "dark"}
        onClick={colorMode.toggleColorMode}
      />
      <IconButton color={mainColor}>
        {theme.palette.mode === "dark" ? <Brightness4 /> : <Brightness7 />}
      </IconButton>
    </Box>
  );
};

function App() {
  return (
    <div>
      <AppBar />
      <React.Suspense fallback={<Loading />}>
        <Bundle />
      </React.Suspense>
      <Analytics />
    </div>
  );
}

export default function ToggleColorMode() {
  const [mode, setMode] = React.useState("dark");
  const colorMode = React.useMemo(
    () => ({
      toggleColorMode: () => {
        setMode((prevMode) => (prevMode === "light" ? "dark" : "light"));
      },
    }),
    []
  );

  const theme = React.useMemo(
    () =>
      createTheme({
        palette: {
          mode,
        },
        typography: {
          fontFamily: ["Poppins", "sans-serif"].join(","),
          body1: {
            fontFamily: "Poppins, sans-serif",
          },
          body2: {
            fontFamily: "Poppins, sans-serif",
          },
        },
      }),
    [mode]
  );

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <div className={`app-${theme.palette.mode}`}>
          <Container maxWidth="lg">
            <App />
          </Container>
        </div>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}
